import React from 'react'
import { Paper, Stack, Group, Divider, Text } from '@mantine/core'
import { IconMessage } from '@tabler/icons-react'
import { SectionLabel } from './SectionLabel'

export const CommentCard = (props: { comment: string }) => {
  const { comment } = props
  return (
    <Paper p="lg" radius="md" withBorder>
      <Stack gap="sm">
        <Group gap="xs">
          <IconMessage size={14} color="var(--mantine-color-brand-6)" stroke={2} />
          <SectionLabel>Commentaire</SectionLabel>
        </Group>
        <Divider />
        <Text size="sm" c="dark.3" style={{ lineHeight: 1.75, fontStyle: 'italic' }}>{comment}</Text>
      </Stack>
    </Paper>
  )
}
